/**
 * Editorial permissions are Django model permissions granted per user in the admin panel.
 *
 * They arrive in the same `userData.permissions` array as the `plans.*` permissions — the backend
 * builds that array from `get_user_permissions()`, which aggregates every auth backend — so they are
 * checked with the same `hasPermission` selector. They are kept apart from `PLAN_PERMISSIONS_NAMES`
 * because they are editorial capabilities, not plan entitlements.
 *
 * Note: `get_user_permissions()` ignores group-inherited permissions, so these must be granted
 * directly on the user. A group grant lets the API accept the call while the UI stays hidden.
 */
export const EDITORIAL_PERMISSIONS_NAMES = {
  CAN_PUBLISH_ANALYSES: "squaber.can_publish_analyses"
};

export default EDITORIAL_PERMISSIONS_NAMES;
